import clsx from 'clsx';
import { Text } from 'components/UI/Typography/Text';

import styles from './StrengthMeter.module.scss';

interface IStrengthMeterProps {
  strengthMeter?: number;
}

export const StrengthMeter = ({ strengthMeter = 0 }: IStrengthMeterProps) => {
  const strengthLineLength: Array<keyof typeof styles> = [
    'strength0',
    'strength1',
    'strength2',
    'strength3',
    'strength4',
    'strength5',
    'strength6',
    'strength7',
    'strength8',
    'strength9',
    'strength10',
  ];

  return (
    <div className={styles.meterWrapper}>
      <Text className={styles.strengthText} variant="subtitle1">
        cycle
      </Text>
      <div className={styles.strengthMeter}>
        <span className={styles.meterSection} role="presentation" />
        <span className={styles.meterSection} role="presentation" />
        <span className={styles.meterSection} role="presentation" />
        <span className={styles.meterSection} role="presentation" />
        <span className={styles.meterSection} role="presentation" />
        <span className={styles.meterSection} role="presentation" />
        <span className={styles.meterLine} role="presentation" />
        <div
          className={clsx(
            styles.strengthLine,
            styles[strengthLineLength[strengthMeter]],
          )}
        >
          {`${strengthMeter} out of 5 strength`}
        </div>
      </div>
    </div>
  );
};
